export const cast = [
    {name: 'Carolyn', 
    tribe: 'Tika',
    status: 'in',
    clicked: false},
    {name: 'Helen',
    tribe: 'Tika',
    status: 'out',
    clicked: false,
    img: ''},
    {name: 'Sarah',
    tribe: 'Tika',
    status: 'out',
    clicked: false,
    img: ''},
    {name: 'Yam-Yam',
    tribe: 'Tika',
    status: 'in',
    clicked: false,
    img: ''},
    {name: 'Bruce',
    tribe: 'Tika',
    status: 'out',
    clicked: false,
    img: ''},
    {name: 'Carson',
    tribe: 'Tika',
    status: 'in',
    clicked: false,
    img: ''},
    {name: 'Brandon',
    tribe: 'Ratu',
    status: 'in',
    clicked: false,
    img: ''},
    {name: 'Kane',
    tribe: 'Ratu',
    status: 'in',
    clicked: false,
    img: ''},
    {name: 'Matthew',
    tribe: 'Ratu',
    status: 'in',
    clicked: false,
    img: ''},
    {name: 'Jaime',
    tribe: 'Ratu',
    status: 'in',
    clicked: false,
    img: ''},
    {name: 'Lauren',
    tribe: 'Ratu',
    status: 'in',
    clicked: false,
    img: ''},
    {name: 'Maddy',
    tribe: 'Ratu',
    status: 'out',
    clicked: false,
    img: ''},
    {name: 'Claire',
    tribe: 'Soka',
    status: 'out',
    clicked: false,
    img: ''},
    {name: 'Frannie',
    tribe: 'Soka',
    status: 'in',
    clicked: false,
    img: ''},
    {name: 'Heidi',
    tribe: 'Soka',
    status: 'in',
    clicked: false,
    img: ''},
    {name: 'Danny',
    tribe: 'Soka',
    status: 'in',
    clicked: false,
    img: ''},
    {name: 'Josh',
    tribe: 'Soka',
    status: 'in',
    clicked: false,
    img: ''},
    {name: 'Matt',
    tribe: 'Soka',
    status: 'in',
    clicked: false,
    img: ''},
]